import script from "./prescription.vue?vue&type=script&setup=true&lang=js"
export * from "./prescription.vue?vue&type=script&setup=true&lang=js"

import "./prescription.vue?vue&type=style&index=0&id=55de2fda&lang=css"

const __exports__ = script;

export default __exports__